import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

export const ContactPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const ContactContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  max-width: 1200px;
  margin: 40px auto;
  margin-bottom: 100px;
  margin-top: 100px;

  @media (max-width: 1335px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const ContactTextContainer = styled.div`
  width: 40%;
  margin-top: 10px;

  @media (max-width: 1335px) {
    width: 80%;
    text-align: center;
  }
`;

export const ContactTextContainerTitle = styled.h3`
  color: #3393f0;
`;

export const ContactTextContainerIntroTitle = styled.h1`
  color: #17224d;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const ContactTextContainerText = styled.p`
  color: #17224d;
`;

export const ContactOpeningHoursContainer = styled.div`
  color: #17224d;
  width: 25%;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
  transition: transform 0.5s;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; /* Centers content vertically */
  &:hover {
    transform: translateY(-10px);
  }

  @media (max-width: 1335px) {
    width: 80%;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 5%;
  }
`;

export const ContactOpeningHoursTitle = styled.div`
  font-weight: bold;
  text-align: center;
`;

export const ContactOpeningHours = styled.div`
  margin-top: 20px;
  text-align: center;
  gap: 10px;
`;

export const ContactOpeningHoursSection = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
`;

export const ContactOpeningHoursIcon = styled(FontAwesomeIcon)`
  font-size: 16px;
  color: #3393f0;
`;

export const ContactEmergencyContainer = styled.div`
  width: 35%;
  padding: 30px;
  color: white;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
  text-align: center;
  background-color: #17224d;
  background-image: url("/assets/bg_3.png");
  background-size: cover;
  background-position: center;
  transition: transform 0.5s;

  &:hover {
    transform: translateY(-10px);
  }

  @media (max-width: 1335px) {
    width: 80%;
    margin-top: 5%;
  }
`;

export const ContactEmergencyDescription = styled.div`
  margin-bottom: 15px;
  margin-left: 20px;

  @media (max-width: 1335px) {
    margin-left: 0;
    text-align: center;
  }
`;

export const ContactEmergencyWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
`;

export const ContactEmergencyTitle = styled.h3`
  font-size: 30px;
  margin-bottom: 15px;
`;

export const ContactEmergencyBottomTitle = styled.h3`
  font-size: 30px;
`;

export const ContactEmergencySection = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;

  @media (max-width: 418px) {
    margin-bottom: 20px;
  }
`;

export const ContactFormContainer = styled.div`
  position: relative;
  width: 100%;
  height: 60vh;
  margin-bottom: 80px;

  @media (max-width: 1335px) {
    height: 120vh;
  }

  @media (max-width: 391px) {
    height: 150vh;
  }

  @media (max-width: 361px) {
    height: 160vh;
  }
`;

export const ContactFormImage = styled.img`
  width: 100%;
  height: 60vh;
  object-fit: cover;
  object-position: center;

  @media (max-width: 1335px) {
    height: 120vh;
  }

  @media (max-width: 391px) {
    height: 150vh;
  }

  @media (max-width: 361px) {
    height: 160vh;
  }
`;

export const ContactFormGradientOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    rgba(255, 255, 255, 0.5),
    rgba(255, 255, 255, 0.5)
  );
  z-index: 1;
`;

export const ContactFormWrapper = styled.div`
  z-index: 3;
  max-width: 1200px;
  position: relative;
  top: -100%;
  margin: 20px auto;
  display: flex;
  flex-direction: row;
  gap: 40px;
  align-items: center;

  @media (max-width: 1335px) {
    flex-direction: column;
  }
`;

export const ContactFormTextContainer = styled.div`
  flex: 1;
  padding: 50px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);

  @media (max-width: 1335px) {
    width: 90%;
    text-align: center;
  }
`;

export const ContactFormTextIntroTitle = styled.h3`
  font-size: 14px;
  color: #3393f0;
  letter-spacing: 2px;
  margin-bottom: 10px;
`;

export const ContactFormTextTitle = styled.h1`
  margin-bottom: 10px;
  color: #17224d;
`;

export const ContactFormTextText = styled.p`
  color: #17224d;
  margin-bottom: 40px;
`;

export const ContactFormTextSectionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0px;
  align-items: flex-start;

  @media (max-width: 1335px) {
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }
`;

export const ContactFormTextSectionLocation = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-right: 20px;
`;

export const ContactFormTextSectionMail = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ContactFormTextSection = styled.div`
  margin-left: 20px;
  color: #17224d;
`;

export const ContactFormTextSectionTitle = styled.div`
  font-weight: bold;
  font-size: 14px;
`;

export const ContactFormTextSectionText = styled.div`
  font-size: 14px;
`;

export const ContactForm = styled.form`
  flex: 1;
  padding: 40px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);

  @media (max-width: 1335px) {
    width: 90%;
  }
`;

export const ContactFormInputRow = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
`;

export const ContactFormInput = styled.input`
  width: 100%;
  padding: 20px;
  font-size: 14px;
  border-radius: 24px;
  background-color: #edf1fc;
  border: none;

  &:focus {
    border-color: #3393f0;
  }
`;

export const ContactFormTextArea = styled.textarea`
  width: 100%;
  padding: 15px;
  font-size: 14px;
  border-radius: 24px;
  max-width: 100%;
  border: none;
  background-color: #edf1fc;
  min-height: 150px;
  font-family: inherit;
  resize: none;

  &:focus {
    border-color: #3393f0;
  }
`;

export const ContactFormButton = styled.button`
  padding: 24px;
  font-size: 16px;
  width: 100%;
  font-weight: bold;
  background-color: #3393f0;
  color: white;
  border: none;
  border-radius: 24px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #2878d3;
  }
`;

export const ContactFormLabel = styled.label`
  font-size: 14px;
  color: #17224d;
  margin-bottom: 8px;
  display: block;
  font-weight: bold;
`;

export const ContactFormMap = styled.iframe`
  width: 100%;
  height: 50vh;
  border: 0;
  height: 50vh;
`;
